import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Box, Typography, Grid } from '@mui/material';
export function SplitScreenLayout({ children, logoTo, logoSrc, logoAlt, appName, subtitle, }) {
    return (_jsx(Box, { component: 'main', sx: {
            display: 'flex',
            flex: '1 1 auto',
            maxWidth: '100%',
            minHeight: '100vh',
        }, children: _jsxs(Grid, { container: true, sx: { flex: '1 1 auto' }, children: [_jsxs(Grid, { xs: 12, lg: 6, sx: {
                        backgroundColor: 'background.paper',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                    }, children: [_jsx(Box, { component: 'header', sx: {
                                left: 0,
                                p: 3,
                                position: 'fixed',
                                top: 0,
                                width: '100%',
                            }, children: _jsx(Box, { component: Link, to: logoTo, sx: {
                                    display: 'flex',
                                    height: 64,
                                    width: 64,
                                }, children: _jsx("img", { src: logoSrc, alt: logoAlt, style: { width: 64, height: 64 } }) }) }), children] }), _jsx(Grid, { xs: 12, lg: 6, sx: {
                        alignItems: 'center',
                        background: 'radial-gradient(50% 50% at 50% 50%, #122647 0%, #090E23 100%)',
                        color: 'white',
                        display: 'flex',
                        justifyContent: 'center',
                        '& img': { maxWidth: '100%' },
                    }, children: _jsxs(Box, { sx: { p: 3 }, children: [_jsxs(Typography, { align: 'center', color: 'inherit', sx: {
                                    fontSize: '24px',
                                    lineHeight: '32px',
                                    mb: 1,
                                }, variant: 'h1', children: ["Willkommen bei", ' ', _jsx(Box, { component: 'span', sx: { color: '#15B79E' }, children: appName })] }), _jsx(Typography, { align: 'center', sx: { mb: 3 }, variant: 'subtitle1', children: subtitle })] }) })] }) }));
}
